import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@core/services/auth.service';
import { map, take } from 'rxjs/operators';

const ADMIN_ROLE_IDS = [1, 2];

/**
 * Guard que restringe el acceso a rutas solo para usuarios con rol Administrador.
 * Redirige a /dashboard/settings/general si el usuario no es admin.
 */
export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);

  return authService.currentUser$.pipe(
    take(1),
    map((user) => {
      const roles = user?.roles ?? [];
      const isAdmin = roles.some((r: { id: number }) =>
        ADMIN_ROLE_IDS.includes(r.id),
      );
      if (isAdmin) {
        return true;
      }
      router.navigate(['/dashboard/settings', 'general']);
      return false;
    }),
  );
};
